// Alarmes do diagnóstico do servidor (docker/service/diag.sh roda a cada minuto)
const STALE_SECONDS = 5 * 60;
const RECENT_BOOT_SECONDS = 60 * 60;

// Servidores monitorados (todos aceitam o mesmo token)
export const SERVERS = [
    { name: "backend.pay4charge.com", api: "https://api.pay4charge.com/" },
    { name: "backend.sdeveloper.work", api: "https://api.sdeveloper.work/" },
    { name: "backend.incharge.app", api: "https://api.incharge.app/" },
];

export function serverAlarms(server) {
    if (!server) return [];
    if (server.unreachable) {
        return [{ critical: true, text: "API do servidor sem resposta" }];
    }
    if (server.status) {
        return [{ critical: false, text: `Erro HTTP ${server.status} ao buscar diagnóstico do servidor` }];
    }
    if (!server.available) {
        return [{ critical: false, text: "Diagnóstico do servidor indisponível (verificar cron do diag.sh)" }];
    }

    const alarms = [];

    if (server.age > STALE_SECONDS) {
        alarms.push({ critical: true, text: `Diagnóstico do servidor desatualizado há ${formatDuration(server.age)} (verificar cron do diag.sh)` });
    }

    const memory = server.memory || {};
    if (memory.percent > 90) {
        alarms.push({ critical: true, text: `Memória RAM com uso muito elevado: ${memory.percent}%` });
    } else if (memory.percent > 80) {
        alarms.push({ critical: false, text: `Memória RAM com uso elevado: ${memory.percent}%` });
    }

    (server.disks || []).forEach((disk) => {
        if (disk.percent > 90) {
            alarms.push({ critical: true, text: `Disco ${disk.mount} com uso muito elevado: ${disk.percent}% (livre ${formatBytes(disk.available)})` });
        } else if (disk.percent > 80) {
            alarms.push({ critical: false, text: `Disco ${disk.mount} com uso elevado: ${disk.percent}% (livre ${formatBytes(disk.available)})` });
        }
        if (disk.inodesPercent > 90) {
            alarms.push({ critical: true, text: `Disco ${disk.mount} sem inodes livres: ${disk.inodesPercent}% em uso` });
        }
    });

    const uptime = (server.uptime || {}).seconds;
    if (uptime < RECENT_BOOT_SECONDS) {
        alarms.push({ critical: false, text: `Servidor reiniciado há ${formatDuration(uptime)}` });
    }

    return alarms;
}

export function formatBytes(value) {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;
    value = value || 0;
    while (value >= 1024 && index < units.length - 1) {
        value /= 1024;
        index++;
    }
    return `${value.toFixed(index > 2 ? 1 : 0)} ${units[index]}`;
}

export function formatDuration(seconds) {
    seconds = seconds || 0;
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}min`;
    return `${minutes}min`;
}
